'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { ACTIVE_QUERY_KEY, createInputStore, queryInputStateContextProvider, useQueryInputSideEffects, } from '#pplx/frontend/apps/ask/stores/queryInput.js';
import React from 'react';
export const QueryInputStateProvider = function QueryInputStateProvider({ children, storageKey = ACTIVE_QUERY_KEY }) {
    const [store] = React.useState(() => createInputStore(storageKey));
    return (_jsx(queryInputStateContextProvider.Provider, { value: store, children: children }));
};
export const QueryInputSideEffects = React.memo(function QueryInputSideEffects() {
    useQueryInputSideEffects();
    return null;
});
//# sourceMappingURL=QueryInputComponents.js.map